import React, { useState, useEffect } from "react";
import EducationComponent from "../../contents/EducationComponent/EducationComponent";
import ExperienceComponent from "../../contents/ExperienceComponent/ExperienceComponent";
import ProfileComponent from "../../contents/ProfileComponent/ProfileComponent";

const Experience = () => {
  const [activeTab, setActiveTab] = useState("education");

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const educationList = document.querySelector(".education-list");
    const experienceList = document.querySelector(".experience-list");
    const profileList = document.querySelector(".profile-list");

    if (activeTab === "education") {
      educationList.style.display = "block";
      experienceList.style.display = "none";
      profileList.style.display = "none";
    } else if (activeTab === "experience") {
      educationList.style.display = "none";
      experienceList.style.display = "block";
      profileList.style.display = "none";
    } else {
      educationList.style.display = "none";
      experienceList.style.display = "none";
      profileList.style.display = "block";
    }
  }, [activeTab]);

  return (
    <>
      <section className="skills" id="experience">
        <div className="skills-content section-content">
          <p className="section-subtitle">My Education &amp Experience</p>
          <h2 className="h3 section-title">
            Exploring My Academic and Professional Journey
          </h2>
          <p className="section-text">
            From academic achievements to hands-on experience, my journey
            encompasses a blend of learning and practical application, shaping
            me into a versatile individual ready to tackle challenges head-on.
          </p>
          <div className="exps-toggle">
            <button
              className={`toggle-btn ${
                activeTab === "education" ? "active" : ""
              }`}
              onClick={() => toggleTab("education")}
              data-target="education"
            >
              Education
            </button>
            <button
              className={`toggle-btn ${
                activeTab === "experience" ? "active" : ""
              }`}
              onClick={() => toggleTab("experience")}
              data-target="experience"
            >
              Experience
            </button>
            <button
              className={`toggle-btn ${
                activeTab === "profile" ? "active" : ""
              }`}
              onClick={() => toggleTab("profile")}
              data-toggle-btn
              data-target="profile"
            >
              Profile
            </button>
          </div>
        </div>

        <div className="skills-box">
          {/* <!-- Education --> */}
          <ul className="education-list">
            <EducationComponent />
          </ul>
          {/* <!-- Experience --> */}
          <ul className="experience-list">
            <ExperienceComponent />
          </ul>
          {/* <!-- Profile --> */}
          <ul className="profile-list">
            <ProfileComponent />
          </ul>
        </div>
      </section>
    </>
  );
};

export default Experience;
